import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { OverlayToggleDirective } from '../../components/overlay/overlay-toggle.directive';
import { ButtonComponent } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';
import { OverlayComponent } from '../../components/overlay/overlay.component';
import { HrefDirective } from '../../directives/href/href.directive';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-rate-of-return-tooltip',
  templateUrl: 'rate-of-return-tooltip.component.html',
  styleUrls: ['rate-of-return-tooltip.component.scss'],
  imports: [
    ButtonComponent,
    OverlayToggleDirective,
    IconComponent,
    TranslateDirective,
    OverlayComponent,
    HrefDirective,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RateOfReturnTooltipComponent {
  @Input() position: string = 'center-bottom';
  @Input('aria-describedby') ariaDescribedBy: string | undefined;
  /* eslint-disable lines-between-class-members */
  @Input()
  set changeLink(value: boolean) {
    this._changeLink = value;
  }
  get changeLink(): boolean { return this._changeLink; }
  /* eslint-enable lines-between-class-members */
  private _changeLink: boolean;
}
